import React from "react"
import { ReactComponent as Klips } from "@images/logo/klips-circle.svg"
import PropTypes from "prop-types"

export const KlipsLogo = ({ height, style }) => (
  <Klips height={height} style={style} />
)

KlipsLogo.defaultProps = {
  height: "50px",
}

KlipsLogo.propTypes = {
  height: PropTypes.string,
  style: PropTypes.object,
}
